import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router';
import { Toaster } from 'sonner';
import { StrictMode } from 'react';
import { Theme } from '@radix-ui/themes';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { FirebaseErrorBoundary } from '@/components/common';
import { CanonicalPath } from '@/components/layout';
import { ConsentProvider } from '@/contexts';
import '@/lib/analytics';
import { queryClient } from '@/lib/react-query';
import { ComponentDemos } from '@/views/dev';
import App from './App.tsx';
import './index.css';
import './lib/i18n';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Theme
      accentColor="red"
      appearance="dark"
      grayColor="gray"
      radius="medium"
      panelBackground="solid"
      scaling="100%"
    >
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <CanonicalPath>
            <Routes>
              {import.meta.env.DEV && (
                <>
                  <Route path="/dev/components" element={<ComponentDemos />} />
                </>
              )}
              <Route
                path="*"
                element={
                  <ConsentProvider>
                    <FirebaseErrorBoundary>
                      <App />
                    </FirebaseErrorBoundary>
                  </ConsentProvider>
                }
              />
            </Routes>
          </CanonicalPath>
        </BrowserRouter>
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
        <Toaster theme="dark" />
      </QueryClientProvider>
    </Theme>
  </StrictMode>
);
